import { xmlNamespaces } from '@qdabra/forms-shared';

import fvNamespaceResolver from "../../../../fvNamespaceResolver";

const { nsDfs } = xmlNamespaces;

const sharePointSoapNamespace = "http://schemas.microsoft.com/sharepoint/soap/";
const qrulesTaxonomyNamespace = "http://qdabra.com/schemas/qrules/taxonomy/";
const sharePointTaxonomyNamespace = "http://schemas.microsoft.com/sharepoint/taxonomy/soap/";

const makeTaxonomyNamespaces = () => {
    let nsr = new fvNamespaceResolver();

    nsr.addNamespace("dfs", nsDfs);
    nsr.addNamespace("ns2", sharePointSoapNamespace);
    nsr.addNamespace("tns", sharePointTaxonomyNamespace);
    nsr.addNamespace("ns1", qrulesTaxonomyNamespace);

    return nsr;
}

export default makeTaxonomyNamespaces;